import * as React from "react";
import { SVGProps } from "react";

const Ravencoin = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 205 338" {...props}>
    <path
      fill="#384182"
      d="M89 274.9 0 338.8l56.5-260zm1.8-.6 54.2.7L58.6 79.8zm59.3-4.3 41.5-153.8L175.9 97zm-20-241.1-68.3 46 99.8-32.3zm-8.6 0-42.4 1.4L72.9 48z"
    />
    <path
      fill="#f79534"
      d="m172.9 91.1-109.3-15 98.5-31zM147 33.3l6-16.3-31.5-13.7zm9.1-17.9 7.1 25.6 42-11.1z"
    />
    <path
      fill="#f0513a"
      d="M147.4 274 59.8 78 174 94zM126.8 28.9 72.8 50l-13 24zm-33.5-16L79.8 27.8l44.8-1.1zm23.6-11.6-21.4 9.9 48.8 21.5zM141.3 0h-23l35.6 13.8zm13.3 18.3-5.5 16.4 11 5.3z"
    />
  </svg>
);

export default Ravencoin;
